/* eslint-disable no-case-declarations */

export const types = {
  SET: "SET_MAIN_MENU",
  RESET: "RESET_MAIN_MENU",
};

export const mainMenuReducer = (state = [], action) => {
  switch (action.type) {
    case types.SET:
      return Array.isArray(action.payload) ? action.payload : [];

    case types.RESET:
      return [];

    default:
      return state;
  }
};
